import React from 'react';
import { NextPage } from 'next';
import { makeStyles } from '@material-ui/core/styles';
import Main from '@/layouts/Main';
import Head from '@/components/common/Head';
import styles from 'styles/jss/original/pages/terms';
import meta from '@/config/meta';
import basicAuthentication from '@/lib/basicAuthentication';
import { wrapper } from '@/store/configureStore';

// @ts-expect-error
const useStyles = makeStyles(styles);

const TermsPage: NextPage = () => {
  const classes = useStyles();

  return (
    <div className={classes.page}>
      <Main>
        <Head
          title={meta.term.title}
          description={meta.term.description}
          image={meta.term.image}
          url={meta.term.url}
        />
        <div className={classes.main}>
          <div className={classes.section}>
            <div className={classes.container}>
              <h1 className={classes.titleLevel2}>利用規約</h1>
              <div>
                <h3 className={classes.title}>第1条（総則）</h3>
                <ol>
                  <li>
                    <p>
                      この利用規約（以下，「本規約」といいます。）は small
                      dish（以下，「当社」といいます。）が提供するサービス（以下，「本サービス」といいます。）の利用条件を定めるものです。本サービスを利用するお客様(以下「ユーザー」といいます。)には本規約に従って本サービスをご利用いただきます。
                    </p>
                  </li>
                  <li>
                    <p>
                      本規約は，ユーザーと当社との間の本サービスの利用に関わる一切の関係に適用されるものとします。
                    </p>
                  </li>
                  <li>
                    <p>
                      当社は本規約を、ユーザーへの予告なしに改定できるものとします。本規約の変更については、過去の規約に優先して適用されるものとし、本サービスに掲載をもって発効するものとします。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第2条（ユーザーの定義と登録）</h3>
                <ol>
                  <li>
                    <p>本サービスのユーザーとは、登録ユーザー並びにゲストユーザーの総称です。</p>
                  </li>
                  <li>
                    <p>
                      登録ユーザーとは、Facebook、Twitter、Googleなどの外部サービスの認証システムを経由して、ユーザー登録を行った個人のことです。
                    </p>
                  </li>
                  <li>
                    <p>
                      ゲストユーザーとは、閲覧などの、前項に定めるユーザー登録を行わずに利用できるサービスを利用する個人のことです。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第3条（外部サービス）</h3>
                <ol>
                  <li>
                    <p>
                      本サービスはFacebook、Twitter、Google等の外部サービスと連携してサービスを提供することがありますが、ユーザーは、自らの責任において外部サービスを利用するものとし、当社は、外部サービスの利用に関連してユーザーに発生した損害について、一切の責任を負いません。
                    </p>
                  </li>
                  <li>
                    <p>
                      ユーザーは、外部サービスの利用に当たっては、外部サービスの利用規約等を遵守するものとします。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第4条（ID・パスワードの管理）</h3>
                <ol>
                  <li>
                    <p>
                      ユーザーは第3条第1項に従い外部サービスのID等を利用して本サービスに登録します。そのため、そのID等の登録、利用については、外部サービスが規定する各規約の定めに従うものとし、当社はその内容について一切の責任を負うものではありません。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第5条（ユーザーの責任）</h3>
                <ol>
                  <li>
                    <p>
                      本サービスをユーザーが利用する場合、インターネットにアクセスする必要がありますが、そのためのあらゆる機器、ソフトウェア、通信手段はユーザーご自身が各自の責任と費用において適切に準備、設置、操作していただく必要があります。当社はユーザーのアクセス環境について一切関与せず、これらの準備、操作に関する責任を負いません。
                    </p>
                  </li>
                  <li>
                    <p>
                      当社より登録ユーザーに対して連絡を行う際には、登録メールアドレスあての電子メールにて連絡を行います。登録ユーザーは当社からの電子メールを受信できるよう登録メールアドレス情報を正しく維持するものとし、何らかの理由で受信ができなくなった場合には、登録ユーザーは速やかに登録メールアドレスの変更を適切に行わなければなりません。当社からの電子メールが受信できなかったためにユーザーが被った不利益については、ユーザー自身に責任があるものとし、当社は一切の責任を負いません。
                    </p>
                  </li>
                  <li>
                    <p>
                      本サービス上においてユーザーが開示した、テキスト、画像および画像に付随する情報や個人情報などを含む全ての情報に関する責任は、ユーザー各自にあります。従って、当社はユーザーが本サービスにおいて開示した情報の内容について、一切の責任を負いません。
                    </p>
                  </li>
                  <li>
                    <p>
                      ユーザーが他人の名誉を毀損した場合、プライバシー権を侵害した場合、著作権法に違反する行為を行った場合、その他他人の権利を侵害した場合、当該ユーザーは自身の責任と費用において解決しなければならず、当社は一切の責任を負いません。
                    </p>
                  </li>
                  <li>
                    <p>
                      ユーザーが開示した情報が原因となって迷惑を受けたとする者が現れた場合には、当該ユーザーは自身の責任と費用において解決しなければならず、当社は一切の責任を負いません。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第6条（禁止事項）</h3>
                <ol>
                  <li>
                    <p>著作権、特許権等の知的財産権を侵害する行為</p>
                  </li>
                  <li>
                    <p>当社の承諾無く本サービスを転用・売却・再販する行為</p>
                  </li>
                  <li>
                    <p>プライバシーを侵害する行為</p>
                  </li>
                  <li>
                    <p>名誉毀損行為、侮辱行為や他者の業務妨害となる行為</p>
                  </li>
                  <li>
                    <p>法令または公序良俗に違反する行為</p>
                  </li>
                  <li>
                    <p>犯罪に関わる行為あるいは法令に違反する行為</p>
                  </li>
                  <li>
                    <p>他者になりすましてサービスを利用したり、情報を改ざんする行為</p>
                  </li>
                  <li>
                    <p>他のユーザーに関する個人情報等を収集または蓄積する行為</p>
                  </li>
                  <li>
                    <p>当社のサーバーまたはネットワークの機能を破壊したり，妨害したりする行為</p>
                  </li>
                  <li>
                    <p>当社のサービスの運営を妨害するおそれのある行為</p>
                  </li>
                </ol>
                <h3 className={classes.title}>第7条（本サービスの変更・廃止）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、本サービスの内容を、ユーザーへの事前の通知なくして変更することがありますが、ユーザーは、それに同意するものとし、ユーザーに不利益または損害が発生したとしても、当社は、一切その責任を負わないものとします。
                    </p>
                  </li>
                  <li>
                    <p>
                      当社は、本サービスを、最低10日間の予告期間をおいて停止または廃止することができます。本サービスの停止または廃止は、本サイト上で告知するものとし、当社が、この手続を行った後に本サービスを停止または廃止した場合には、当社は、一切の損害賠償等の責任を負わないものとします。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第8条（著作権などの取扱い）</h3>
                <ol>
                  <li>
                    <p>
                      本サービスで提供されるあらゆるコンテンツ（文章、写真、図形、動画、音声ファイル等）の著作権は、当社または、寄稿者、カメラマンなど、正当な権利を持つ第三者に帰属します。著作権者の許諾なく著作物を利用することが法的に認められる場合を除き、無断での複製、公衆送信、翻訳・翻案、配布等は認められません。
                    </p>
                  </li>
                  <li>
                    <p>
                      {' '}
                      本サービス上の著作物を、いかなる手段、媒体であっても、当社に無断で全部または一部を複製、改変、転用、再配布、販売、他の著作物と合成することを禁止いたします。
                    </p>
                  </li>
                  <li>
                    <p>
                      記事の引用については、著作権法に基づく正当な引用の範囲に留めていただくと共に、引用元（出所）の明示を条件とします。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第9条（利用規約の変更）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、必要と判断した場合には、ユーザーに通知することなくいつでも本規約およびプライバシーポリシーを変更することができるものとします。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第10条（本サービスの一時的な中断）</h3>
                <ol>
                  <li>
                    <p>
                      当社はユーザーに事前の告知なく、以下の理由にて本サービスを停止することがあります。なお、当社は本サービスの停止によるユーザー又は第三者の被った不利益・損害に関して、一切の責任を負わないものとします。
                    </p>
                    <ul>
                      <li>
                        <p>本サービスの保守、改修をするとき</p>
                      </li>
                      <li>
                        <p>火災、停電などによりシステム機器等のトラブルがあったとき</p>
                      </li>
                      <li>
                        <p>
                          天変地異、戦争、動乱、労働争議などにより本サービスの提供ができなくなったとき
                        </p>
                      </li>
                      <li>
                        <p>
                          その他、運用上、技術上、当社が本サービスの停止を行う必要があると判断したとき
                        </p>
                      </li>
                    </ul>
                  </li>
                </ol>
                <h3 className={classes.title}>第11条（プライバシー）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、本サービスを提供するにあたり必要となる最小限の情報をユーザーから取得します。当社は、ユーザーから取得したプライバシー情報の保護に最大限の注意を払います。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第12条（広告の配信及び解析等）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、本サービスにおいて、ユーザーの動向を調査する為にファーストパーティーcookieにより、匿名の統計的な利用情報を取得しています。
                    </p>
                  </li>
                  <li>
                    <p>
                      当社は、本サービス上において、当社の裁量に基づいて、本規約に従って広告を掲載することができるものとし、ユーザーはこれを予め承諾するものとします。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第13条（免責）</h3>
                <ol>
                  <li>
                    <p>
                      当社は、本サービスの利用により発生した利用者の損害については、一切の賠償責任を負いません。
                    </p>
                  </li>
                  <li>
                    <p>
                      利用者が、本サービスを利用することにより、第三者に対し損害を与えた場合、利用者は自己の費用と責任においてこれを賠償するものとします。
                    </p>
                  </li>
                  <li>
                    <p>
                      当社は本サービスに発生した不具合、エラー、障害等により本サービスが利用できないことによって引き起こされた損害について一切の賠償責任を負いません。
                    </p>
                  </li>
                  <li>
                    <p>
                      本サービス上のコンテンツおよび情報は、当社がその時点で提供可能なものとします。当社は提供する情報、利用者が登録・送信（発信）する文章その他のコンテンツおよびソフトウェア等の情報について、その完全性、正確性、適用性、有用性、利用可能性、安全性、確実性等につきいかなる保証もしません。
                    </p>
                  </li>
                  <li>
                    <p>
                      本サービスが何らかの外的要因により、データ破損等をした場合、当社はその責任を負いません。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第14条（本規約の譲渡）</h3>
                <ol>
                  <li>
                    <p>
                      当社は本サービスにかかる事業を他社に譲渡した場合には、当該事業譲渡に伴い利用契約上の地位、本規約に基づく権利および義務ならびに利用者の利用者情報を当該事業譲渡の譲受人に譲渡することができるものとし、利用者は、かかる譲渡につき本項において予め同意したものとします。なお、本項に定める事業譲渡には、通常の事業譲渡のみならず、会社分割その他事業が移転するあらゆる場合を含むものとします。
                    </p>
                  </li>
                </ol>
                <h3 className={classes.title}>第15条（準拠法および合意管轄）</h3>
                <ol>
                  <li>
                    <p>
                      本規約に関する準拠法は、日本法とします。当社と利用者の間に生ずる争いで訴訟を提起する場合は、東京地方裁判所を第一審の専属管轄裁判所とします。
                    </p>
                  </li>
                </ol>
              </div>
              <div>
                <p className={classes.pullRight}>(2020年7月1日 制定)</p>
              </div>
            </div>
          </div>
        </div>
      </Main>
    </div>
  );
};

export const getServerSideProps = wrapper.getServerSideProps(async ({ req, res }) => {
  if (!process.browser) {
    basicAuthentication({ req, res });
  }
});

export default TermsPage;
